import {
  CHUNK_END_SEPARATOR,
  DataStreamPrefixSchema,
  ERROR_PREFIX,
  STRING_PREFIX,
  ToolCall,
  TOOLCALL_PREFIX,
  ToolCallSchema,
  TOOLRESULT_PREFIX,
  ToolResultDto,
  ToolResultDtoSchema,
} from '@endion/types';

export async function* readDataStream({ reader }: { reader: ReadableStreamDefaultReader<Uint8Array> }): AsyncGenerator<
  | { type: typeof STRING_PREFIX; value: string }
  | { type: typeof TOOLCALL_PREFIX; value: ToolCall }
  | {
      type: typeof TOOLRESULT_PREFIX;
      value: ToolResultDto;
    }
  | { type: typeof ERROR_PREFIX; value: string }
> {
  const decoder = new TextDecoder();
  let done = false;
  let buffer = ''; // Buffer to hold partial chunks

  while (!done) {
    const { value, done: doneReading } = await reader.read();
    done = doneReading;
    // If there is no value, continue to the next iteration
    if (!value) continue;
    // Decode the value and append it to the buffer
    buffer += decoder.decode(value, { stream: true });

    // Process all complete chunks within the buffer
    let separatorIndex;
    // if buffer includes separator ':', then process it
    while ((separatorIndex = buffer.indexOf(':')) !== -1) {
      const prefix = DataStreamPrefixSchema.parse(buffer.slice(0, separatorIndex));

      // Find the next chunk end character character after the separator
      const endIndex = buffer.indexOf(CHUNK_END_SEPARATOR, separatorIndex + 1);
      // If no chunk end character character is found, that means that the chunk is incomplete
      // and we should wait for the next chunk to complete it
      if (endIndex === -1) {
        break;
      }
      // Extract the text value between the ':' and the newline character, that should be a complete chunk
      const content = buffer.slice(separatorIndex + 1, endIndex);
      // Remove the processed chunk from the buffer
      buffer = buffer.slice(endIndex + 1);
      try {
        switch (prefix) {
          case 'STRING':
            yield { type: STRING_PREFIX, value: content };
            break;
          case 'TOOLCALL': {
            const toolCall = ToolCallSchema.parse(JSON.parse(content));
            yield { type: TOOLCALL_PREFIX, value: toolCall };
            break;
          }
          case 'TOOLRESULT': {
            const toolResult = ToolResultDtoSchema.parse(JSON.parse(content));
            yield { type: TOOLRESULT_PREFIX, value: toolResult };
            break;
          }
          case 'ERROR': {
            console.log('ERROR IN READ STREAM DATA', content);
            yield { type: 'ERROR', value: content };
            break;
          }
          default:
            console.warn('Unknown chunk prefix:', prefix);
        }
      } catch (e) {
        console.error('Error parsing chunk:', e);
      }
    }
  }
}
